import { makeAutoObservable } from "mobx";
import { Auth } from 'aws-amplify';
import { toast } from 'react-toastify';
import environment from '../environments';

class ProfileStore {
  constructor() {
    makeAutoObservable(this);
  }

  user = {}
  passwords = {
    oldPassword: null,
    newPassword: null,
    newPasswordConfirmation: null,
    confirmed: false
  }

  mail = {
    newEmailAddress: null,
    newEmailAddressConfirmation: null,
    confirmationCode: null,
    confirmed: false,
    verificationCode: null
  }

  getUserDetails() {
    Auth.currentAuthenticatedUser({
      bypassCache: true
    })
      .then((user) => {
        this.user = user.attributes;
      })
      .catch((error) => {
        console.log(error)
      });
  }

  changePassword() {
    if (this.passwords.confirmed) {
      Auth.currentAuthenticatedUser({
        bypassCache: true
      })
        .then(user => {
          return Auth.changePassword(user, this.passwords.oldPassword, this.passwords.newPassword);
        })
        .then((data) => {
          this.passwords = {
            oldPassword: null,
            newPassword: null,
            newPasswordConfirmation: null
          }

          if (data === "SUCCESS") {
            toast.success("Kennwort erfolgreich geändert.");
          } else {
            toast.error("Kennwort konnte nicht geändert werden.");
          }
          this.getUserDetails();
        })
        .catch((error) => {
          console.log(error);
          toast.error("Kennwort konnte nicht geändert werden.");
        });
    }
  }

  changeEmailAddress() {
    if (this.mail.confirmed) {
      Auth.currentAuthenticatedUser({
        bypassCache: true
      })
        .then(user => {
          return Auth.updateUserAttributes(user, { 'email': this.mail.newEmailAddress })
        })
        .then((data) => {
          this.mail = {
            newEmailAddress: null,
            newEmailAddressConfirmation: null,
            verificationCode: null
          }

          if (data === "SUCCESS") {
            toast.success("E-Mail Adresse erfolgreich geändert.");
          } else {
            toast.error("E-Mail Adresse konnte nicht geändert werden.");
          }
          this.getUserDetails();
        })
        .catch((error) => {
          console.log(error);
          toast.error("E-Mail Adresse konnte nicht geändert werden.");
        });
    }
  }

  requestVerificationCode() {
    Auth.verifyCurrentUserAttribute("email")
      .then(() => {
        toast.success("Bestätigungscode erfolgreich verschickt.");
      }).catch((e) => {
        toast.error("Bestätigungscode konnte nicht verschickt werden.");
      });
  }



  verifyEmailAddress() {
    if (this.mail.verificationCode !== null) {
      Auth.verifyCurrentUserAttributeSubmit("email", this.mail.verificationCode)
        .then(() => {
          toast.success("E-Mail Adresse erfolgreich verifiziert.");
          this.getUserDetails();
        }).catch(e => {
          toast.error("E-Mail Adresse konnte nicht verifiziert werden.");
          this.getUserDetails();
        });
    }
  }

  deleteProfile() {
    Auth.currentSession()
      .then((token) => {
        fetch(environment.API_HOST + "/profile", {
          method: 'DELETE',
          headers: {
            "Authorization": "Bearer " + token.getAccessToken().getJwtToken(),
            "Content-Type": "application/json"
          }
        })
          .then((response) => response.json())
          .then((json) => {
            /* If the stickers have been deleted, delete the profile form Cognito */
            Auth.currentAuthenticatedUser()
              .then((user) => {
                user.deleteUser(error => {
                  if (error) {
                    toast.error("Benutzerkonto konnte nicht gelöscht werden.");
                  } else {
                    Auth.signOut();
                  }
                });
              })
              .catch(e => {
                toast.error("Benutzerkonto konnte nicht gelöscht werden.");
              });
          })
          .catch((error) => {
            toast.error(String(error));
            console.log(error);
          })
      })
      .catch((error) => {
        toast.error("Benutzerkonto konnte nicht gelöscht werden.");
        return error;
      })
  }

}

const profileStore = new ProfileStore();
export default profileStore;